export default "__VITE_ASSET__143ec1cf__"